import { useMainKeyVisualAndKeyVisuals } from "@/components/features/_hooks/use-main-kv-and-kvs";
import type { UseMainKeyVisualAndKeyVisualsReturnType } from "@/components/features/_hooks/use-main-kv-and-kvs/use-main-kv-and-kvs";

import type { HotelSettingsHotelInfoFormModelOnSetViewModelType } from "../..";
import type { HotelSettingsHotelInfoFormModel } from "../../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];
	onSetViewModel: HotelSettingsHotelInfoFormModelOnSetViewModelType;
};

export type HotelSettingsHotelInfoFormModelKeyVisualMethodsType = {
	keyVisualMethods: UseMainKeyVisualAndKeyVisualsReturnType;
};

export const useHotelInfoKeyVisual = ({ viewModel, onSetViewModel }: Props) => {
	return {
		keyVisualMethods: {
			...useMainKeyVisualAndKeyVisuals({
				keyVisuals: viewModel.keyVisuals ?? undefined,
				mainKeyVisual: viewModel.mainKeyVisual ?? undefined,
				onSetMainKeyVisual: onSetViewModel,
				onSetKeyVisuals: onSetViewModel,
			}),
		},
	};
};
